export const DEFAULT_SIGNATORY_COUNTRY = "United Arab Emirates";
export const MAX_PO_BOX_LENGTH = 10;
export const MAX_OFFICE_NUMBER_LENGTH = 50;
export const MAX_STREET_NUMBER_LENGTH = 50;
export const MAX_FLAT_NUMBER_FIELD_LENGTH = 10;
